import { defineComponent as _defineComponent } from 'vue'
import type { MonetizationType } from '@/@types/graphql-types';

import { MonetizationTypes } from '@/interfaces/titles';

import ToggleButton from '@/ui-components/ToggleButton.vue';

import { usePlotRecommenderStore } from './usePlotRecommenderStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'PlotRecommenderMonetizationType',
  setup(__props) {

const prStore = usePlotRecommenderStore();

// not all monetization options should be shown, there are some
// that should not be selected
const options = MonetizationTypes.filter(f => f.visible) // show only visible types
	.sort((a, b) => a.priority - b.priority); // order by priority ASC

function toggle(monetizationType: MonetizationType) {
	if (prStore.filters.monetizationTypes.includes(monetizationType)) {
		prStore.filters.monetizationTypes = prStore.filters.monetizationTypes.filter(m => m !== monetizationType);
	} else {
		prStore.filters.monetizationTypes.push(monetizationType);
	}
}

return { __sfc: true,prStore, options, toggle, ToggleButton }
}

})